import React from 'react';

/**
 * ProtectedImage Component
 * Protects images from casual downloading with:
 * - Transparent overlay (clicks don't reach the image)
 * - Right-click disabled
 * - Drag disabled
 * - Selection disabled
 */
const ProtectedImage = ({ 
  src, 
  alt, 
  className = '', 
  containerClassName = '',
  onMouseEnter,
  onMouseLeave,
  ...props 
}) => {
  const handleContextMenu = (e) => {
    e.preventDefault();
    return false;
  };

  const handleDragStart = (e) => {
    e.preventDefault();
    return false;
  };

  return (
    <div 
      className={`relative ${containerClassName}`}
      onContextMenu={handleContextMenu}
    >
      {/* The actual image */}
      <img
        src={src}
        alt={alt}
        className={`${className} select-none pointer-events-none`}
        draggable={false}
        onDragStart={handleDragStart}
        onContextMenu={handleContextMenu}
        {...props}
      />
      
      {/* Transparent overlay - captures all mouse events */}
      <div 
        className="absolute inset-0 z-10"
        onContextMenu={handleContextMenu}
        onDragStart={handleDragStart}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{ 
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
        }}
      />
    </div>
  );
};

export default ProtectedImage;
